export const siteInfo = {
  name: '90影视',
  slogan: '8090后专属影视平台，好剧一网打尽',
  intro: '90影视专注为8090后影迷打造一站式高清观影平台，汇集国产热播剧、经典韩剧、热门综艺、人气动漫及院线大片，每日更新不中断。无论你是剧荒患者还是追番达人，这里都有你想要的精彩内容。全站高清画质、极速加载，全集不缓冲，让你告别卡顿，享受纯粹观影体验。',
  stats: [
    { label: '日更剧集', value: '200+' },
    { label: '高清片源', value: '10万+' },
    { label: '在线稳定', value: '99.9%' },
  ],
  navLinks: [
    { label: '首页', href: '#hero' },
    { label: '热播榜单', href: '#ranking' },
    { label: '联系我们', href: '#contact' },
    { label: '观众热评', href: '#comments' },
    { label: '焦点专题', href: '#carousel' },
    { label: '关于我们', href: '#about' },
  ],
};

export const comments = [
  {
    id: 1,
    name: '追剧小达人',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20with%20warm%20studio%20lighting%20on%20simple%20neutral%20background%2C%20clean%20minimal%20photography%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
    rating: 5,
    content: '自从发现90影视，追剧效率翻倍！国产剧更新速度没得说，画质也很清晰，已经安利给办公室所有同事了。',
    date: '2026-07-28',
    tags: ['国产剧', '更新快'],
  },
  {
    id: 2,
    name: '韩剧迷妹阿琳',
    avatar: 'https://readdy.ai/api/search-image?query=Asian%20woman%20casual%20portrait%20warm%20lighting%20simple%20background%20clean%20minimal%20style&width=80&height=80&seq=avatar-02&orientation=squarish',
    rating: 5,
    content: '韩剧资源真的太全了！之前找了好几个站都没有的最新韩剧这里居然有，而且翻译质量很高，感动哭。',
    date: '2026-07-26',
    tags: ['韩剧', '翻译好'],
  },
  {
    id: 3,
    name: '动漫老炮阿飞',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20portrait%20warm%20studio%20lighting%20simple%20neutral%20background%20clean%20minimal%20style&width=80&height=80&seq=avatar-03&orientation=squarish',
    rating: 4,
    content: '动漫区分类很清晰，新番老番都能找到。就是希望国漫板块再多一点内容，总体体验还是很棒的。',
    date: '2026-07-25',
    tags: ['动漫', '国漫'],
  },
];

export const contactInfo = {
  title: '联系我们',
  description: '欢迎影视爱好者投稿、反馈或商务合作。90影视致力于为8090后打造最好的影视平台，你的每一个建议我们都认真对待。',
  email: 'contact@90ys.com',
  wechat: 'ys90official',
  qq: '3045678901',
};

export const faqs = [
  {
    id: 1,
    question: '90影视需要注册会员才能观看吗？',
    answer: '不需要。90影视所有内容完全免费开放，无需注册、无需登录，点开即看。我们坚持零门槛观影体验，让每一位影迷都能轻松享受高清影视内容。',
  },
  {
    id: 2,
    question: '网站的视频画质怎么样？支持哪些清晰度？',
    answer: '90影视全站提供高清画质，主流内容支持1080P，部分热门资源可达4K超清。我们采用先进的CDN加速技术，确保播放流畅不卡顿，适配不同网络环境自动调整最佳清晰度。',
  },
  {
    id: 3,
    question: '更新频率如何？新剧什么时候上线？',
    answer: '国产热播剧通常在卫视播出后2小时内更新，韩剧字幕版一般当天晚上上线，综艺和动漫保持同步更新节奏。我们拥有专业的资源团队，确保内容第一时间与观众见面。',
  },
  {
    id: 4,
    question: '支持手机和平板观看吗？有没有APP？',
    answer: '90影视网站采用响应式设计，完美适配手机、平板和电脑端，无需下载任何软件即可在浏览器中畅快追剧。我们也正在开发移动端专属APP，敬请期待。',
  },
];

export const updates = [
  {
    id: 1,
    date: '2026-08-01',
    tag: '新剧上线',
    title: '《长安十二时辰》第二季正式上线',
    summary: '备受期待的国产古装悬疑大剧第二季今日在90影视独家首播，原班人马回归，剧情更加烧脑。',
  },
  {
    id: 2,
    date: '2026-07-31',
    tag: '热门综艺',
    title: '《奔跑吧》最新季完整版已更新',
    summary: '国民综艺《奔跑吧》新一季全期高清完整版已同步上线，笑点密集，周末必看。',
  },
  {
    id: 3,
    date: '2026-07-30',
    tag: '韩剧专题',
    title: '八月韩剧追剧日历发布',
    summary: '整理了八月份即将上线的热门韩剧追剧日历，包括多部期待已久的续作和全新力作。',
  },
  {
    id: 4,
    date: '2026-07-29',
    tag: '动漫推荐',
    title: '暑期必看动漫清单TOP20',
    summary: '精选20部适合暑期观看的动漫作品，涵盖热血、治愈、悬疑等多个类型，总有一部适合你。',
  },
  {
    id: 5,
    date: '2026-07-28',
    tag: '电影速递',
    title: '院线热片《消失的夜晚》高清版已上线',
    summary: '豆瓣评分8.7的悬疑电影《消失的夜晚》高清版正式登陆90影视，反转结局令人拍案叫绝。',
  },
  {
    id: 6,
    date: '2026-07-27',
    tag: '站点公告',
    title: '服务器全面升级，观影体验再提升',
    summary: '90影视已完成服务器集群升级扩容，全站加载速度提升40%，卡顿率降至新低。',
  },
  {
    id: 7,
    date: '2026-07-26',
    tag: '新剧上线',
    title: '《春色寄情人》全集上线，都市情感力作',
    summary: '近期口碑爆棚的都市情感剧《春色寄情人》全集已更新完毕，一口气追完太过瘾。',
  },
  {
    id: 8,
    date: '2026-07-25',
    tag: '站点活动',
    title: '「追剧达人」暑期活动火热进行中',
    summary: '参与追剧打卡活动，分享你的追剧心得，赢取精美影视周边礼品，详情见站内公告。',
  },
];

export const ranking = [
  {
    rank: 1,
    title: '长安十二时辰 第二季',
    category: '国产剧',
    hot: '986万',
    trend: 'up',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20drama%20poster%20style%20with%20warm%20amber%20tones%2C%20Tang%20dynasty%20atmosphere%2C%20cinematic%20composition%2C%20dramatic%20lighting%2C%20clean%20background%20with%20subtle%20texture&width=200&height=280&seq=rank-01&orientation=portrait',
  },
  {
    rank: 2,
    title: '春色寄情人',
    category: '国产剧',
    hot: '874万',
    trend: 'up',
    image: 'https://readdy.ai/api/search-image?query=Modern%20romantic%20Chinese%20drama%20poster%20style%20warm%20spring%20tones%2C%20emotional%20urban%20romance%20atmosphere%2C%20soft%20cinematic%20lighting%2C%20clean%20minimal%20composition&width=200&height=280&seq=rank-02&orientation=portrait',
  },
  {
    rank: 3,
    title: '首尔之恋',
    category: '韩剧',
    hot: '762万',
    trend: 'new',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20romantic%20poster%20style%20soft%20pastel%20tones%2C%20Seoul%20cityscape%20background%2C%20emotional%20couple%20silhouette%2C%20cinematic%20warm%20lighting&width=200&height=280&seq=rank-03&orientation=portrait',
  },
  {
    rank: 4,
    title: '奔跑吧 第十二季',
    category: '综艺',
    hot: '691万',
    trend: 'stable',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20energetic%20poster%20style%20bright%20colorful%20tones%2C%20dynamic%20group%20composition%2C%20fun%20vibrant%20atmosphere%2C%20clean%20poster%20design&width=200&height=280&seq=rank-04&orientation=portrait',
  },
  {
    rank: 5,
    title: '进击的巨人 最终季',
    category: '动漫',
    hot: '638万',
    trend: 'up',
    image: 'https://readdy.ai/api/search-image?query=Epic%20anime%20action%20poster%20style%20dramatic%20warm%20orange%20tones%2C%20cinematic%20composition%2C%20heroic%20figure%20silhouette%2C%20clean%20minimal%20background&width=200&height=280&seq=rank-05&orientation=portrait',
  },
];

export const indexTopics = [
  { id: 1, title: '国产热播剧', count: 128, icon: 'ri-tv-line', desc: '实时更新最新国产电视剧，古装、现代、悬疑一网打尽' },
  { id: 2, title: '韩剧专区', count: 96, icon: 'ri-heart-line', desc: '最新最全韩剧资源，浪漫爱情到烧脑悬疑' },
  { id: 3, title: '热门综艺', count: 85, icon: 'ri-live-line', desc: '各大卫视及网络平台综艺节目高清更新' },
  { id: 4, title: '动漫番剧', count: 203, icon: 'ri-rocket-line', desc: '日漫国漫全覆盖，新番老番随时回顾' },
  { id: 5, title: '电影大全', count: 567, icon: 'ri-film-line', desc: '院线大片、经典老片、独立佳片应有尽有' },
  { id: 6, title: '纪录片库', count: 89, icon: 'ri-global-line', desc: '自然、历史、科技类纪录片精选合集' },
  { id: 7, title: '少儿频道', count: 62, icon: 'ri-emotion-laugh-line', desc: '优质少儿动画和教育内容，家长放心之选' },
  { id: 8, title: '短剧精选', count: 156, icon: 'ri-smartphone-line', desc: '精品短剧、微短剧，碎片时间也能追好剧' },
];

export const features = [
  {
    id: 1,
    icon: 'ri-4k-line',
    title: '超高清画质',
    desc: '全站支持1080P及以上画质，热门内容可达4K超清，给你电影院般的视觉享受。',
  },
  {
    id: 2,
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '卫视播出后最快2小时内同步更新，专业团队24小时待命，追剧从不掉队。',
  },
  {
    id: 3,
    icon: 'ri-smartphone-line',
    title: '多端适配',
    desc: '手机、平板、电脑无缝切换，响应式设计自动适配各种屏幕，随时随地想看就看。',
  },
  {
    id: 4,
    icon: 'ri-shield-check-line',
    title: '纯净观影',
    desc: '无弹窗广告干扰，无需注册登录，打开即看，专注为你提供最纯粹的观影环境。',
  },
  {
    id: 5,
    icon: 'ri-global-line',
    title: '海量片库',
    desc: '超十万部影视资源持续扩充，国产剧韩剧综艺动漫全覆盖，总有你想看的内容。',
  },
];

export const aboutInfo = {
  title: '关于90影视',
  content: '90影视诞生于2020年，由一群热爱影视的8090后共同创建。我们深知同龄人对优质影视内容的渴望 —— 忙碌工作之余，一部好剧就是最好的放松。五年如一日，我们坚持每日更新、专注高清画质、追求极致观影体验。从最初的小众分享站到如今服务数百万影迷的综合平台，90影视始终不忘初心：让每一个人都能轻松找到并享受自己喜欢的影视内容。我们相信，好的内容值得被更多人看到，这也是90影视持续前行的最大动力。',
  stats: [
    { label: '运营年数', value: '5+' },
    { label: '影视资源', value: '10万+' },
    { label: '日活用户', value: '百万级' },
    { label: '更新速度', value: '≤2小时' },
  ],
};

export const mediaItems = [
  {
    id: 1,
    title: '《长安十二时辰》第二季 先导预告',
    type: '预告片',
    duration: '02:35',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cinematic%20ancient%20Chinese%20drama%20scene%20with%20warm%20amber%20lighting%2C%20Tang%20dynasty%20setting%2C%20dramatic%20atmosphere%2C%20film%20grain%20texture%2C%20movie%20poster%20style&width=640&height=360&seq=media-01&orientation=landscape',
  },
  {
    id: 2,
    title: '八月韩剧追剧指南 | 必看片单',
    type: '盘点',
    duration: '05:18',
    thumbnail: 'https://readdy.ai/api/search-image?query=Korean%20drama%20collage%20montage%20style%20warm%20romantic%20tones%2C%20Seoul%20city%20night%20background%2C%20cinematic%20composition%2C%20soft%20dreamy%20lighting&width=640&height=360&seq=media-02&orientation=landscape',
  },
  {
    id: 3,
    title: '暑期必看动漫TOP20 | 宅家追番指南',
    type: '盘点',
    duration: '07:42',
    thumbnail: 'https://readdy.ai/api/search-image?query=Anime%20collage%20style%20vibrant%20colorful%20composition%20with%20warm%20energy%2C%20summer%20theme%2C%20cinematic%20atmosphere%2C%20clean%20modern%20design&width=640&height=360&seq=media-03&orientation=landscape',
  },
];

export const appEntry = {
  title: '随时随地 追剧不停',
  description: '90影视移动端专属页面已上线，手机浏览器访问即可获得原生APP般的流畅体验。无需下载安装，扫码或直接访问，好剧随身带。',
  features: ['全屏沉浸观影', '续播记忆功能', '省流量模式', '夜间模式保护视力'],
  qrImage: 'https://readdy.ai/api/search-image?query=Minimalist%20QR%20code%20style%20pattern%20on%20clean%20white%20background%2C%20modern%20tech%20aesthetic%2C%20simple%20geometric%20design&width=200&height=200&seq=qr-code&orientation=squarish',
};

export const topics = [
  { id: 1, name: '国产剧', count: '128万讨论', hot: true },
  { id: 2, name: '韩剧', count: '96万讨论', hot: true },
  { id: 3, name: '综艺', count: '85万讨论', hot: false },
  { id: 4, name: '动漫', count: '203万讨论', hot: true },
  { id: 5, name: '电影', count: '567万讨论', hot: false },
  { id: 6, name: '纪录片', count: '32万讨论', hot: false },
  { id: 7, name: '古装剧', count: '156万讨论', hot: true },
  { id: 8, name: '悬疑剧', count: '89万讨论', hot: false },
  { id: 9, name: '爱情剧', count: '112万讨论', hot: false },
  { id: 10, name: '喜剧', count: '74万讨论', hot: false },
  { id: 11, name: '科幻', count: '58万讨论', hot: false },
];

export const carouselItems = [
  {
    id: 1,
    title: '盛夏追剧指南',
    subtitle: '暑期档热门影视大盘点',
    desc: '这个夏天不容错过的国产剧、韩剧、综艺和动漫，90影视为你一网打尽，空调WiFi追剧模式开启。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20evening%20scene%20with%20warm%20golden%20light%2C%20cozy%20living%20room%20with%20TV%20screen%20glowing%2C%20relaxing%20atmosphere%2C%20soft%20bokeh%20effect%2C%20film%20poster%20aesthetic&width=800&height=450&seq=carousel-01&orientation=landscape',
    tag: '热门专题',
  },
  {
    id: 2,
    title: '国产古装剧复兴',
    subtitle: '那些让8090后痴迷的经典',
    desc: '从《琅琊榜》到《长安十二时辰》，国产古装剧经历了怎样的蜕变？回顾那些年我们一起追过的古装神作。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20architecture%20cinematic%20scene%20with%20warm%20golden%20amber%20lighting%2C%20dramatic%20atmosphere%2C%20misty%20mountains%20background%2C%20film%20poster%20style%2C%20epic%20scale&width=800&height=450&seq=carousel-02&orientation=landscape',
    tag: '深度专题',
  },
  {
    id: 3,
    title: '韩剧二十年',
    subtitle: '从《蓝色生死恋》到今天的追剧记忆',
    desc: '韩剧陪伴8090后走过青春岁月，那些年哭过笑过的经典韩剧，你还记得多少？重温韩剧带给我们的感动。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20nostalgic%20scene%20warm%20soft%20lighting%2C%20autumn%20leaves%20and%20romantic%20atmosphere%2C%20cinematic%20composition%2C%20dreamy%20film%20aesthetic%2C%20emotional%20tone&width=800&height=450&seq=carousel-03&orientation=landscape',
    tag: '怀旧专题',
  },
  {
    id: 4,
    title: '动漫新番速递',
    subtitle: '2026夏季新番导视全攻略',
    desc: '本季新番亮点抢先看，热血、治愈、悬疑、搞笑一应俱全，90影视为你精选最值得追的动漫新作。',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20anime%20style%20summer%20scene%20with%20colorful%20illustration%20aesthetic%2C%20dynamic%20composition%2C%20warm%20sunlight%2C%20clean%20modern%20design%2C%20cinematic%20feel&width=800&height=450&seq=carousel-04&orientation=landscape',
    tag: '新番专题',
  },
  {
    id: 5,
    title: '综艺名场面盘点',
    subtitle: '那些笑到头掉的经典瞬间',
    desc: '从《奔跑吧》到各大热门综艺，8090后的快乐源泉大盘点。每一个名场面都是我们共同的欢乐记忆。',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20energetic%20variety%20show%20studio%20scene%20with%20bright%20warm%20lighting%2C%20entertaining%20atmosphere%2C%20dynamic%20composition%2C%20fun%20vibrant%20aesthetic&width=800&height=450&seq=carousel-05&orientation=landscape',
    tag: '盘点专题',
  },
  {
    id: 6,
    title: '8090后观影图鉴',
    subtitle: '我们的青春藏在哪些片子里',
    desc: '每个8090后心中都有一部不可替代的影视作品，它定义了我们的某个阶段。翻开这份观影图鉴，看看你的青春属于哪一部。',
    image: 'https://readdy.ai/api/search-image?query=Nostalgic%20retro%20cinema%20scene%20with%20warm%20vintage%20tones%2C%20film%20projector%20and%20old%20movie%20posters%2C%20cozy%20atmosphere%2C%20cinematic%20composition%2C%20soft%20filmic%20lighting&width=800&height=450&seq=carousel-06&orientation=landscape',
    tag: '情怀专题',
  },
];

export const cards = [
  {
    id: 1,
    title: '国产剧「质感」时代来临',
    category: '深度分析',
    desc: '从服化道到剧本打磨，近年国产剧的制作水准大幅提升。90影视为你盘点那些堪称「电影质感」的国产好剧。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20historical%20drama%20set%20design%20with%20warm%20rich%20textures%2C%20intricate%20costume%20details%2C%20soft%20dramatic%20lighting%2C%20film%20production%20aesthetic&width=600&height=400&seq=card-01&orientation=landscape',
    date: '2026-07-30',
  },
  {
    id: 2,
    title: '为什么8090后爱看韩剧？',
    category: '文化观察',
    desc: '从偶像剧到现实题材，韩剧为何能持续俘获8090后的心？探讨韩剧的情感共鸣与文化吸引力。',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20Korean%20drama%20watching%20scene%20with%20warm%20ambient%20lighting%2C%20comfortable%20living%20space%2C%20emotional%20atmosphere%2C%20cinematic%20composition%2C%20soft%20focus&width=600&height=400&seq=card-02&orientation=landscape',
    date: '2026-07-28',
  },
  {
    id: 3,
    title: '综艺节目的「内卷」与创新',
    category: '行业观察',
    desc: '国内综艺市场竞争白热化，从模式引进到原创输出，综艺节目正在经历一场深刻的变革。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20TV%20production%20studio%20with%20colorful%20lighting%20setup%2C%20professional%20equipment%2C%20creative%20atmosphere%2C%20warm%20vibrant%20tones%2C%20cinematic%20documentary%20style&width=600&height=400&seq=card-03&orientation=landscape',
    date: '2026-07-26',
  },
  {
    id: 4,
    title: '国漫崛起：不止是说说而已',
    category: '产业趋势',
    desc: '从《哪吒》到《深海》，国漫在技术和故事上都在发生质的飞跃。90影视持续关注国漫发展的每一个里程碑。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20art%20style%20with%20vibrant%20colors%20and%20traditional%20elements%2C%20modern%20fusion%20aesthetic%2C%20warm%20cinematic%20lighting%2C%20clean%20composition&width=600&height=400&seq=card-04&orientation=landscape',
    date: '2026-07-24',
  },
  {
    id: 5,
    title: '碎片时间追剧指南',
    category: '实用攻略',
    desc: '工作忙没时间追长剧？90影视精选优质短剧和迷你剧，每集10-15分钟，通勤午休随时看，追剧零压力。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20commuter%20watching%20smartphone%20on%20train%20with%20warm%20natural%20lighting%2C%20urban%20lifestyle%20scene%2C%20cozy%20atmosphere%2C%20cinematic%20documentary%20style&width=600&height=400&seq=card-05&orientation=landscape',
    date: '2026-07-22',
  },
];